// import { getStringParam } from './urlParams';
import * as easing from '@/core/easing';

// -------------------- Types

type AnimModeType = 'none' | 'subtle' | 'all';

interface ImageAnimConfig {
  duplicates: { scale: number }[];
  duration: number;
  ease: string;
}

interface HeadlineAnimConfig {
  charDistance: string;
  charOpacity: number;
  duration: number;
  ease: string;
  stagger: number;
}

export interface AnimValsType {
  once: boolean;
  opacity: number;
  ease: any;

  sm: {
    distance: string;
    duration: number;
    delay: number;
    ease: any;
    triggerPercent: number;
  };

  lg: {
    distance: string;
    duration: number;
    delay: number;
    ease: any;
    triggerPercent: number;
  };

  ImageAnim: ImageAnimConfig;
  HeadlineAnim: HeadlineAnimConfig;
}

export const DEFAULT_MODE: AnimModeType = 'subtle';

// -------------------- Determine mode

/*
// Determine animation mode from URL param
const rawParam = getStringParam('AnimMode', DEFAULT_MODE);

// Normalize rawParam
const normalizedMode: AnimModeType = (() => {
  const val = rawParam == null ? '' : String(rawParam).trim().toLowerCase();
  if (val === '') return DEFAULT_MODE;
  if (val === 'subtle') return 'subtle';
  // Accept both 'original' and 'all' as the full-animations mode
  if (val === 'original' || val === 'all') return 'all';
  // Unknown values -> default
  return DEFAULT_MODE;
})();

// Finalize mode value
export const AnimMode: AnimModeType = normalizedMode;
*/

export const AnimMode: AnimModeType = 'subtle';

// -------------------- Define value sets

// "Subtle"
const SUBTLE_VALUES: AnimValsType = {
  once: true,
  opacity: 0,
  ease: easing.easeOutCubic,

  sm: {
    distance: '5rem',
    duration: 0.72,
    delay: 0.08,
    ease: easing.easeOutCubic,
    triggerPercent: 0.2,
  },

  lg: {
    distance: '7rem',
    duration: 0.64,
    delay: 0.35,
    ease: easing.easeOutCubic,
    triggerPercent: 0.2,
  },

  ImageAnim: {
    duplicates: [
      { scale: 0.85 },
      { scale: 0.75 },
      { scale: 0.65 }
    ],
    duration: 0.9,
    ease: 'power3.out'
  },

  HeadlineAnim: {
    charDistance: '100%',
    charOpacity: 1,
    duration: 0.9,
    ease: 'power3.out',
    stagger: 0.014
  }
};

// -------------------- Export final values

// export const AnimVals: AnimValsType = (AnimMode === 'all') ? ALL_VALUES : (AnimMode === 'subtle' ? SUBTLE_VALUES : NONE_VALUES);
export const AnimVals: AnimValsType = SUBTLE_VALUES;
